export const isFetching = state =>
  state.integrations.eventbrite.events.fetching;
export const events = state => state.integrations.eventbrite.events.events;
